var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('my-group-head'),_c('v-btn',{attrs:{"to":"/"}},[_vm._v("home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }